import { SidebarMobileToggle } from '@components/Sidebar/MobileToggle'
import { useConnectionProvider } from '@plug-core/state'
import { ListGroup, ListRow, RowTile, Text } from '@ui'
import { ROUTES } from '@utils/routes'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AppearanceRow } from './Components/AppearanceRow'

interface SettingsItem {
  emoji: string
  primaryText: string
  secondaryText: string
  route: string
  navState?: { isPem: boolean }
}

const Settings: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { provider } = useConnectionProvider()

  const items: (SettingsItem | false)[] = [
    !provider && {
      emoji: '🔑',
      primaryText: t('settings.seedPhrase.primaryText'),
      secondaryText: t('settings.seedPhrase.secondaryText'),
      route: ROUTES.KEY_REVEAL_ACCEPTANCE,
    },
    !provider && {
      emoji: '📱',
      primaryText: t('settings.dapps.primaryText'),
      secondaryText: t('settings.dapps.secondaryText'),
      route: ROUTES.CONNECTED_APPS,
    },
    {
      emoji: '💵',
      primaryText: t('settings.locale.primaryText'),
      secondaryText: t('settings.locale.secondaryText'),
      route: ROUTES.LOCALE_SETTINGS,
    },
    {
      emoji: '⛓️',
      primaryText: t('settings.evms.primaryText'),
      secondaryText: t('settings.evms.secondaryText'),
      route: ROUTES.MANAGE_EVM,
    },
    !provider && {
      emoji: '🔐',
      primaryText: t('settings.pem.primaryText'),
      secondaryText: t('settings.pem.secondaryText'),
      route: ROUTES.KEY_REVEAL_ACCEPTANCE,
      navState: { isPem: true },
    },
    {
      emoji: '🧪',
      primaryText: t('settings.testnet.primaryText'),
      secondaryText: t('settings.testnet.secondaryText'),
      route: ROUTES.DEVELOPER_SETTINGS,
    },
  ]
  const list = items.filter((item): item is SettingsItem => !!item)

  return (
    <div className="mb-3 flex flex-col gap-4">
      <SidebarMobileToggle title={t('topbar.settings')} />

      <ListGroup>
        <AppearanceRow />
      </ListGroup>

      <ListGroup>
        {list.map((item) => (
          <ListRow
            key={item.primaryText}
            leading={<RowTile>{item.emoji}</RowTile>}
            primary={item.primaryText}
            secondary={item.secondaryText}
            chevron
            onClick={() => navigate(item.route, { state: item.navState })}
          />
        ))}
      </ListGroup>

      <Text variant="caption" tone="fg-3" align="center">
        v{import.meta.env.VITE_APP_VERSION}
      </Text>
    </div>
  )
}

export default Settings
